export const TREATMENTS_IMAGES = {
  select: {
    dermatology: "/treatments/dermatology.svg",
    plasticSurgery: "/treatments/plastic-surgery.svg",
    dentistry: "/treatments/dentistry.svg",
    healthCheckUp: "/treatments/health-checkup.svg",
  },
  deselect: {
    dermatology: "/treatments/dermatology-deselect.svg",
    plasticSurgery: "/treatments/plastic-surgery-deselect.svg",
    dentistry: "/treatments/dentistry-deselect.svg",
  },
}
